import { render, staticRenderFns } from "./matching-badge-list.vue?vue&type=template&id=0e6c3720&scoped=true&"
import script from "./matching-badge-list.vue?vue&type=script&lang=ts&"
export * from "./matching-badge-list.vue?vue&type=script&lang=ts&"
import style0 from "./matching-badge-list.vue?vue&type=style&index=0&id=0e6c3720&lang=scss&scoped=true&"
import style1 from "./matching-badge-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c3720",
  null
  
)

export default component.exports